<template>
  <nav
    class="navbar navbar-expand navbar-light d-none d-md-flex px-6"
    id="topbar"
  >
    <div class="container-fluid">
      <router-link :to="$paths.validator">
        <img src="@/assets/images/logo.png" alt="" height="40" />
      </router-link>

      <nav aria-label="breadcrumb" class="me-auto ms-4">
        <ol class="breadcrumb fw-bold">
          <router-link v-slot="{ navigate }" custom v-if="link" :to="link">
            <li
              @click="navigate"
              class="breadcrumb-item d-flex align-items-center"
            >
              <a>
                {{ linkName }}
              </a>
            </li>
          </router-link>
          <router-link
            v-slot="{ navigate }"
            custom
            v-if="sublink"
            :to="sublink"
          >
            <li
              @click="navigate"
              class="breadcrumb-item d-flex align-items-center"
            >
              <a>{{ sublinkName }}</a>
            </li>
          </router-link>
          <li
            class="breadcrumb-item active d-flex align-items-center"
            aria-current="page"
          >
            {{ current }}
          </li>
        </ol>
      </nav>

      <div class="navbar-user" v-if="session">
        <!-- <ul class="navbar-nav">
          <router-link active-class="router-link-active" :to="$paths.validator">
            <li class="nav-item">
              <a class="nav-link text-paragraph">Validar outra receita</a>
            </li>
          </router-link>
        </ul> -->
        <router-link
          tag="button"
          :to="$paths.validator"
          class="btn btn-outline-primary"
          >Validar outra receita</router-link
        >
        <span class="ps-4 pe-3 text-paragraph text-muted">|</span>
        <div
          class="dropdown cursor-pointer align-items-center d-flex"
          @mouseover="avatarOver"
          @mouseleave="avatarLeave"
        >
          <span class="text-subtitle me-3">{{ session?.name }}</span>
          <a href="#" class="avatar avatar-sm dropdown-toggle">
            <i class="fa-solid fa-user-circle display-3 text-primary"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-end cursor-pointer">
            <span @click="logout" class="dropdown-item text-danger">Sair</span>
          </div>
        </div>
      </div>
      <div v-else>
        <router-link
          tag="button"
          :to="$paths.login"
          class="btn btn-outline-primary"
          >Entrar</router-link
        >
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
// @ts-ignore
import $ from "jquery";
import { useMainStore } from "@/store";
import { mapState } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Navbar",
  props: {
    link: String,
    linkName: String,
    sublink: String,
    sublinkName: String,
    current: String,
  },
  computed: {
    ...mapState(useMainStore, ["session"]),
  },
  methods: {
    async logout() {
      this.$authService.logout();
      this.$router.push(this.$paths.validator);
    },
    avatarOver() {
      $(".dropdown-menu").addClass("show");
      $(".dropdown-menu").attr("data-bs-popper", true);
    },
    avatarLeave() {
      $(".dropdown-menu").removeClass("show");
      $(".dropdown-menu").removeAttr("data-bs-popper");
    },
  },
});
</script>
